import axios from "axios";
import { Config } from "../../../core/config/config";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/air/air`;

export const airService = {
    messaging: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/messaging`, params)
            .then((response) => {
                return response.data;
            });
    },


    downloadFile: async function (params: any, file: string) {
        return axios.get(`${GATEWAY_URL}/message-file?Id=` + params, { responseType: 'blob' }).then((response) => {
            const contentDisposition = response.headers['content-disposition'];
            console.log(file)
            let fileName = file.split('/')[1];

            // Dosya adını Content-Disposition başlığından al
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match) {
                    fileName = match[1];
                }
            }

            // İçerik türünden dosya uzantısını belirle
            const mimeType = response.headers['content-type'];
            const extension = (mimeType && typeof mimeType === 'string') ? mimeType.split('/')[1] : '';

            if (!fileName.includes('.') && extension) {
                fileName += `.${extension}`;
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); // Temizlik
        }).catch((error) => {
            console.error('Dosya indirilirken hata oluştu:', error);
        });
    },

    getMessageHistory: async function () {
        return axios.get(`${GATEWAY_URL}/message-history`)
        .then((response) => {
            return response.data;
        });
    },

    sendFeedback: async function (params: any) {
        return axios.put(`${GATEWAY_URL}/message-feedback`, params)
            .then((response) => {
                return response.data;
            });
    },
}